export default __webpack_public_path__ + "images/profile_f91a58.svg";